export default "/images/a07dccb15440c6231078ea6f2fede0c8.avif";